import { createFileRoute } from "@tanstack/react-router";
import { AospVsCertifiedAtvPage } from "@/components/guides/AospVsCertifiedAtvPage";
import { aospVsCertifiedAtvSeo } from "@/lib/page-seo";

export const Route = createFileRoute("/guides/aosp-vs-certified-android-tv")({
  loader: ({ location }) => ({ href: location.href }),
  head: ({ loaderData }) =>
    aospVsCertifiedAtvSeo(loaderData?.href ?? "/guides/aosp-vs-certified-android-tv"),
  component: AospVsCertifiedAtvPage,
});
